import { render, staticRenderFns } from "./PontoDeVenda.vue?vue&type=template&id=2df4dd8f"
import script from "./PontoDeVenda.vue?vue&type=script&lang=js"
export * from "./PontoDeVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports